import script from "./Contract.vue?vue&type=script&setup=true&lang=js"
export * from "./Contract.vue?vue&type=script&setup=true&lang=js"

import "./Contract.vue?vue&type=style&index=0&id=45af270a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45af270a"]])

export default __exports__